import React from "react";
import { Container } from "react-bootstrap";

const Services = () => {
	const Service = (props) => {
		return (
			<div className="d-flex flex-column flex-lg-row py-4 px-lg-5">
				<h3 className="d-flex justify-content-center align-items-center col-12 col-lg-4 m-0 mb-3 mb-lg-0">{props.title}</h3>
				<p className="text-justify col-12 col-lg-8 m-0">{props.description}</p>
			</div>
		);
	};
	const Separator = () => <div className="bg-blue m-3" style={{ minWidth: "1px", minHeight: "2px" }} />;

	return (
		<Container className="py-5 px-4 px-lg-0">
			<p className="text-justify text-md-center mb-5 col-12 p-0">
				Contamos con servicios de Asesoría, Defensa y Representación Jurídica en diferentes áreas del Derecho.
			</p>
			<Separator />
			<Service
				title={<span className="text-green">ASESORÍA {<br className="d-block d-md-none d-lg-block" />} JURÍDICA</span>}
				description="Llevamos a cabo un análisis minucioso y personalizado, basado en la experiencia y conocimiento a fin de brindarle un asesoramiento y orientación asertivo que garantice la mejor solución en cada planteamiento legal."
			/>
			<Separator />
			<Service
				title={<span className="text-green">DEFENSA & REPRESENTACIÓN</span>}
				description="Llevamos a cabo un análisis minucioso y personalizado, basado en la experiencia y conocimiento a fin de brindarle un asesoramiento y orientación asertivo que garantice la mejor solución en cada planteamiento legal.  Contamos con las siguientes áreas especializadas en Derecho:"
			/>
			<Separator />
			<Service
				title={<span className="text-gray">ADMINISTRATIVO</span>}
				description="Defensa, asesoría y representación contra actos ilegales y/o arbitrarios de autoridades fiscales, administrativas y jurisdiccionales​, federales o locales, derivados de Créditos Fiscales, Embargos, Inmovilización de Cuentas Bancarias, Cancelación de Sellos Digitales, entre otros."
			/>
			<Separator />
			<Service
				title={<span className="text-gray">AMPARO</span>}
				description="Te asesoramos y defendemos en caso de que alguna autoridad haya violentado tus derechos humanos. Amparos Directos e Indirectos."
			/>
			<Separator />
			<Service
				title={<span className="text-gray">PENAL</span>}
				description="Defensa en delitos del fuero común y federal, interposición de querellas y/o denuncias, asesoría y representación a victimas, acuerdos reparatorios, suspensión condicional del proceso, procedimientos abreviados, medidas cautelares, beneficios preliberatorios a sentenciados, delitos fiscales. Trámite de fianzas y sustitución de garantías."
			/>
			<Separator />
			<Service
				title={<span className="text-gray">CIVIL & {<br className="d-block d-md-none d-lg-block" />} FAMILIAR</span>}
				description="Demandas, contestaciones de demanda, convenios, conciliaciones. Divorcios, custodias, adopciones, pensiones alimenticias, reconocimientos de paternidad y autorizaciones judiciales. "
			/>
			<Separator />
			<Service
				title={<span className="text-gray">INMOBILIARIO</span>}
				description="Contratos de compraventa, arrendamientos, regularización de predios, juicios sucesorios, traspaso y recuperación de inmuebles. "
			/>
			<Separator />
			<Service
				title={<span className="text-gray">MERCANTIL</span>}
				description="Recuperación de cartera, demandas,  ejecución, convenios, seguimiento a deudores."
			/>
			<Separator />
			<Service
				title={<span className="text-gray">LABORAL</span>}
				description="Atención a empresas en contratos colectivos, despidos, representación ante autoridades, atención especial a jubilados de ISSSTE, IMSS e ISSSTECALI."
			/>
			<Separator />
		</Container>
	);
};

export default Services;
